/**
 * Marketing API franchise/office IDs are integers today. Sanity officeID may
 * be fractional (e.g. 104.1). Floor until the API accepts floats, then update
 * or remove this helper.
 */
function normalizeOfficeId(officeId: number): number {
  return Math.floor(officeId);
}

export { normalizeOfficeId };
